module.exports = __webpack_public_path__ + "static/img/chatroom_bkg.c92bbf63.png";